/**
 * Controller: PosCreateImagesRemoveModal
 */
angular.module('acme.view.application.pos.create.images.removeModal.controllers', [])
.controller('PosCreateImagesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentImage', function ($scope, $uibModalInstance, currentImage) {

    $scope.errors = [];

    $scope.model = {
      url: (currentImage) ? currentImage.imageUrl : false
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);